import { Search } from '@pyt/icons'
import { Input, Space, Text } from '@pyt/micros'
import { useContext, useEffect, useState } from 'react'
import { ScrollView } from 'react-native'

import isIxigoPartnersSite from '../../utils/isIxigoPartnersSite'
import {
	ARRIVAL_AIRPORT_CHANGE,
	DEPARTURE_AIRPORT_CHANGE,
	INTL_FLIGHTS_BOOKED,
	SET_ENABLE_GET_COST,
} from './Constants'
import GCMContext from './GCMContext'
import { AirportCityList } from './macros/AirportCityList'

const AirportCityDropdown = ({
	// placeholder,
	listData = [],
	callBackAction = () => {},
	// arrowLeft = true,
	// arrowCenter = false,
	// arrowRight = false,
	// minHeight,
	// position,
	// positionTop,
	// positionLeft,
	disableFooter = false,
	// transform,
	// zIndex,
	// inputRef,
	// trackerClass,
	itineraryInfo,
	// isPDG,
	isLoggedIn,
}) => {
	const [{ arrivalAirport = {} }, dispatch] = useContext(GCMContext)
	const isIxigoPartnersSiteValue = isIxigoPartnersSite()
	const departFromOutSide = e => {
		e && e.preventDefault()
		onCityChange('$$$', 'Outside India')
	}

	const returnFlight = e => {
		e && e.preventDefault()
		onCityChange(false)
	}

	const [searchText, setSearchText] = useState(null)
	const [list, setList] = useState(listData)

	const onSearch = e => {
		if (e) {
			setSearchText(e)
		} else {
			setSearchText(null)
		}
	}

	useEffect(() => {
		if (!searchText) {
			setList(listData)
			return
		}
		const val = searchText.toLowerCase()
		const newList = listData.filter(item => {
			return `${item.label}_${item.value}`.toLowerCase().indexOf(val) > -1
		})

		setList(newList)
	}, [searchText, listData])

	// let hideOutsideIndia = false;

	const onCityChange = (value, text) => {
		let finalData = {}
		if (value) {
			// if (changeActionType === DEPARTURE_AIRPORT_CHANGE) {
			finalData.departureAirport = value
			dispatch({
				type: DEPARTURE_AIRPORT_CHANGE,
				payload: {
					departureAirport: value,
					departureAirportText: text,
				},
			})
			/**
			 * update arrival airport code on the below cases
			 * CASE 1: assign $$$ when departure is outside india/flights already booked
			 * CASE 2: assign departureAirport value when arrivalAirport value is '$$$' and departureAirport is not '$$$'
			 */
			if (value === '$$$' || (value !== '$$$' && arrivalAirport === '$$$')) {
				dispatch({
					type: ARRIVAL_AIRPORT_CHANGE,
					payload: {
						arrivalAirport: value,
						arrivalAirportText: value === '$$$' ? '' : text,
					},
				})
			}
			// } else if (changeActionType === ARRIVAL_AIRPORT_CHANGE) {
			//   finalData.arrivalAirport = value;
			//   dispatch({
			//     type: ARRIVAL_AIRPORT_CHANGE,
			//     payload: {
			//       arrivalAirport: value,
			//       arrivalAirportText: text
			//     }
			//   });
			// }
		} else {
			finalData.flightsBookedByUserAlready = true
			finalData.departureAirport = '$$$'
			finalData.arrivalAirport = '$$$'

			dispatch({
				type: DEPARTURE_AIRPORT_CHANGE,
				payload: {
					departureAirport: '$$$',
					departureAirportText: 'Flights booked',
				},
			})

			dispatch({
				type: ARRIVAL_AIRPORT_CHANGE,
				payload: {
					arrivalAirport: '$$$',
					arrivalAirportText: '',
				},
			})

			dispatch({
				type: INTL_FLIGHTS_BOOKED,
				payload: {
					flightsBookedByUserAlready: true,
				},
			})
		}

		dispatch({
			type: SET_ENABLE_GET_COST,
			payload: {
				itineraryInfo,
				isLoggedIn,
			},
		})

		typeof callBackAction === 'function' && callBackAction(finalData)
	}

	return (
		<Space gutter={[12, 0]} direction="column" height={'100%'}>
			<Space.Item
				width="100%"
				height="60px"
				paddingVertical={12}
				paddingHorizontal={24}
			>
				<Input
					placeholder={'Search cities'}
					value={searchText}
					onChange={onSearch}
					icon={Search}
					padding={8}
					backgroundColor={'rgb(247, 247, 247)'}
					borderRadius={25}
					width="100%"
					focusProps={{
						borderColor: isIxigoPartnersSiteValue ? '#FF4D01' : '#00c584',
					}}
				/>
			</Space.Item>
			<Space.Item height="calc(100% - 128px)">
				<ScrollView>
					<AirportCityList
						listData={list}
						callBackAction={onCityChange}
						padding={'48px 24px'}
						isIxigoPartnersSite={isIxigoPartnersSiteValue}
					/>
				</ScrollView>
			</Space.Item>
			{!disableFooter ? (
				<div
					style={{
						display: 'flex',
						boxShadow: '0px -1px 10px rgba(48, 80, 89, 0.3)',
						position: 'fixed',
						bottom: 0,
						backgroundColor: '#fff',
					}}
				>
					<Space
						gutter={0}
						width={'100%'}
						separator={
							<Space.Item
								width={1}
								backgroundColor="rgba(0, 0, 0, 0.1)"
								height="100%"
							/>
						}
					>
						<Space.Item flex={1} padding={'12px'} width={'50%'} flexWrap="wrap">
							{/* {!hideOutsideIndia ? ( */}
							<Text textAlign="center" onPress={e => departFromOutSide(e)}>
								I’m departing from Outside India
							</Text>
							{/* ) : null} */}
						</Space.Item>
						<Space.Item flex={1} padding={'12px'} width={'50%'} flexWrap="wrap">
							<Text textAlign="center" onPress={e => returnFlight(e)}>
								I have booked my flights already
							</Text>
						</Space.Item>
					</Space>
				</div>
			) : null}
		</Space>
	)
}

export default AirportCityDropdown
